import i18n from '../../i18n';

const base = 'modules.shared.aiAgent';

export const mp = (moduleId, key, opts) =>
  i18n.t(`${base}.moduleRegistry.modules.${moduleId}.${key}`, opts);

export const qp = (moduleId, chipKey, field, opts) =>
  i18n.t(`${base}.quickChipsByModule.${moduleId}.${chipKey}.${field}`, opts);

export const tabP = (key, opts) => i18n.t(`${base}.workspaceTabs.${key}`, opts);

const rs = (key, opts) => i18n.t(`${base}.moduleRegistry.shared.${key}`, opts);

export function chip(label, prompt) {
  return { label, prompt };
}

export function buildDefaultQuickChips(moduleId) {
  const shortLabel = mp(moduleId, 'shortLabel');
  return [
    chip(rs('chip_summary'), rs('prompt_summary', { shortLabel })),
    chip(rs('chip_analytics'), rs('prompt_analytics', { shortLabel })),
    chip(rs('chip_help'), mp(moduleId, 'focusPrompt')),
    chip(rs('chip_navigation'), rs('prompt_navigation', { shortLabel })),
  ];
}

export function buildModuleQuickChips(moduleId, chipKeys) {
  return chipKeys.map((key) => chip(qp(moduleId, key, 'label'), qp(moduleId, key, 'prompt')));
}

export function buildPromptAddon(moduleId) {
  return rs('promptAddon', {
    shortLabel: mp(moduleId, 'shortLabel'),
    domains: mp(moduleId, 'domains'),
  });
}
